import { useDispatch, useSelector } from 'react-redux';
import './css/dashboard.css';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import './css/mobile.css';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle, setMyData } from '../store';
import axios from 'axios';
import { LoadingModal, MessageModal } from './component/modal/modal';
import { Landmark } from 'lucide-react';
import { changeNum } from './common/function';
import List from './component/list/list';
import Chart from 'react-apexcharts';
import VeritasonTransferModal from './component/VeritasonTransferModal';
import { buildWalletWithdrawalRequest } from './component/walletWithdrawal';
import { VERITASON_WALLET_TRANSFER_ENABLED } from '../config/features';

import { FreeMode, Pagination, Autoplay, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleDollarToSlot, faFileCircleCheck } from "@fortawesome/free-solid-svg-icons";

const WalletTransferModal = VERITASON_WALLET_TRANSFER_ENABLED ? VeritasonTransferModal : TransferModal;

function Dashboard() {
    let dispatch = useDispatch()
    let navigate = useNavigate()

    const swiperRef = useRef(null);

    let MyData = useSelector((state) => { return state.MyData })

    useEffect(() => {
        dispatch(change_Current_Location("대시보드"))
        dispatch(changeHeaderTitle({
            mainTitle: "대시보드",
            subTitle: ""
        }))
    }, [])

    const [balance, setBalance] = useState([])
    const [walletBalance, setWalletBalance] = useState([])
    // 매출 섹션: 'current' = 금일·당월, 'past' = 전일·전월
    const [salesRangeTab, setSalesRangeTab] = useState('current')

    // 매출 구간 날짜 표시용 (금일/전일/당월/전월)
    const salesDates = useMemo(() => {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)
        const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
        return {
            todayStr: `${today.getMonth() + 1}월 ${today.getDate()}일`,
            yesterdayStr: `${yesterday.getMonth() + 1}월 ${yesterday.getDate()}일`,
            currentMonthStr: `${today.getFullYear()}년 ${today.getMonth() + 1}월`,
            lastMonthStr: `${lastMonth.getFullYear()}년 ${lastMonth.getMonth() + 1}월`,
        }
    }, [])

    useEffect(() => {
        WalletBalance()
        Balance();

        const interval = setInterval(() => {
            WalletBalance();
            Balance();
        }, 10000);

        // 클린업 함수
        return () => {
            clearInterval(interval);
        };
    }, [])

    const Balance = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/user-wallet/balance", {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                // console.log(tmp)
                const wallet = tmp?.data?.wallet ?? []
                const fee = tmp?.data?.withdrawal_fee
                setBalance({
                    ...wallet,
                    effective_withdrawal_fee: fee ?? null,
                    has_pay_password: tmp?.data?.has_pay_password ?? false,
                    registered_bank_cd: wallet.bank_cd ?? null,
                    registered_bank_nm: wallet.bank_nm ?? null,
                    registered_accnt_no: wallet.accnt_no ?? null,
                    registered_accnt_nm: wallet.accnt_nm ?? null,
                    saved_other_accounts: tmp?.data?.saved_other_accounts ?? [],
                })
            } else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const WalletBalance = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/dashboard/info", {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                // console.log(tmp)
                setWalletBalance(tmp?.data ?? [])
            } else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const onClickHistory = () => {
        navigate('/paylist')
    }

    const onClickSearch = () => {

    }

    const ICON = {
        order: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="4" y="4" width="16" height="16" rx="3" stroke="#16639C" strokeWidth="1.8" />
                <line x1="7" y1="9" x2="17" y2="9" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
                <line x1="7" y1="13" x2="17" y2="13" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
                <line x1="7" y1="17" x2="12" y2="17" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
        ),
        shop: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M5 10h14l-1.2 9H6.2L5 10Z" stroke="#16639C" strokeWidth="1.8" strokeLinejoin="round" />
                <path d="M7 10V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4" stroke="#16639C" strokeWidth="1.8" />
                <circle cx="9" cy="14" r="1" fill="#16639C" /><circle cx="15" cy="14" r="1" fill="#16639C" />
            </svg>
        ),
        history: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="3.5" y="4" width="17" height="14.5" rx="2.5" stroke="#16639C" strokeWidth="1.8" />
                <rect x="6.5" y="7" width="6" height="4" rx="1" stroke="#16639C" strokeWidth="1.8" />
                <line x1="13.5" y1="13" x2="18.5" y2="13" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
                <line x1="13.5" y1="16" x2="18.5" y2="16" stroke="#16639C" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
        ),
        settle: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="4" y="6" width="16" height="12" rx="2.5" stroke="#16639C" strokeWidth="1.8" />
                <rect x="6.5" y="9" width="6" height="4" rx="1" stroke="#16639C" strokeWidth="1.8" />
                <circle cx="17" cy="15" r="1.6" fill="#16639C" />
            </svg>
        ),
    };

    const items = [
        { key: "order", label: "거래조회", icon: ICON.order, link: "/paylist" },
        { key: "shop", label: "정산내역", icon: ICON.order, link: "/settlement" },
        { key: "shop", label: "입출금내역", icon: ICON.order, link: "/withdraw" },
        { key: "history", label: "URL상품관리", icon: ICON.shop, link: "/urlCreate" },
        { key: "settle", label: "URL결제관리", icon: ICON.order, link: "/urlHistory" },
    ];

    function RefreshIcon(props) {
        return (
            <svg viewBox="0 0 24 24" width={18} height={18} aria-hidden="true" {...props}>
                <path
                    d="M17.65 6.35A7.95 7.95 0 0 0 12 4a8 8 0 1 0 7.9 9.2 1 1 0 0 0-2-.3 6 6 0 1 1-1.55-5.4L15 9h6V3l-2.35 2.35z"
                    fill="currentColor"
                />
            </svg>
        );
    }

    const [open, setOpen] = useState(false);
    const [transferError, setTransferError] = useState(null);
    const [withdrawTimeWindowFrom4030, setWithdrawTimeWindowFrom4030] = useState(null);

    const withdrawWindow = useMemo(() => {
        if (balance?.withdrawAllowedStart != null && balance?.withdrawAllowedEnd != null) {
            return { start: balance.withdrawAllowedStart, end: balance.withdrawAllowedEnd };
        }
        return withdrawTimeWindowFrom4030;
    }, [balance?.withdrawAllowedStart, balance?.withdrawAllowedEnd, withdrawTimeWindowFrom4030]);

    const isOutsideWithdrawWindow = useMemo(() => {
        if (!withdrawWindow?.start || !withdrawWindow?.end) return false;
        return !isTimeInWithdrawWindow(withdrawWindow.start, withdrawWindow.end);
    }, [withdrawWindow]);

    const onTransfer = async (amount, accountInfo, payPassword, requestId) => {
        try {
            const body = buildWalletWithdrawalRequest(amount, accountInfo, payPassword, requestId);
            const response = await axios.post(process.env.REACT_APP_API + "/api/user-wallet/withdraw", body, {
                withCredentials: true,
            });
            const tmp = response?.data;
            const succeeded = VERITASON_WALLET_TRANSFER_ENABLED ? tmp?.code === 1000 : tmp?.code < 2000;
            if (succeeded) {
                setTransferError(null);
                await Balance();
                alert(tmp?.msg);
                return { ok: true };
            }
            if (tmp?.code === 9999) {
                navigate('/');
                return { ok: false, msg: '로그인 상태를 확인해주세요.' };
            }
            if (tmp?.code >= 4000 && tmp?.code < 5000) {
                const data = tmp?.data ?? {};
                setTransferError({
                    msg: tmp?.msg ?? '오류가 발생했습니다.',
                    withdrawAllowedStart: data.withdrawAllowedStart,
                    withdrawAllowedEnd: data.withdrawAllowedEnd,
                });
                if (tmp?.code === 4030 && data.withdrawAllowedStart != null && data.withdrawAllowedEnd != null) {
                    setWithdrawTimeWindowFrom4030({ start: data.withdrawAllowedStart, end: data.withdrawAllowedEnd });
                }
                return { ok: false, code: tmp?.code, msg: tmp?.msg, data };
            }
            return { ok: false, msg: tmp?.msg ?? '송금 처리 결과를 확인하지 못했습니다.' };
        } catch (error) {
            console.error(error);
            if (VERITASON_WALLET_TRANSFER_ENABLED) {
                const msg = error.response?.data?.msg ?? '송금 처리 결과를 확인하지 못했습니다. 입출금내역을 확인하거나 다시 확인해주세요.';
                setTransferError({ msg });
                return { ok: false, msg };
            }
            navigate("/");
            return { ok: false };
        }
    };

    const handleOpenTransferModal = () => {
        setTransferError(null);
        setOpen(true);
    };

    const handleCloseTransferModal = () => {
        setOpen(false);
        setTransferError(null);
    };

    return (
        <div className="flex overflow-hidden">
            {open && (
                <WalletTransferModal
                    currentBalance={balance?.total_balance ?? 0}
                    withdrawable={balance?.available_balance ?? 0}
                    withdrawalFee={balance?.effective_withdrawal_fee}
                    registeredAccount={
                        balance?.registered_accnt_no
                            ? { bankCd: balance.registered_bank_cd, bankName: balance.registered_bank_nm, account: balance.registered_accnt_no, accountName: balance.registered_accnt_nm }
                            : null
                    }
                    hasPayPassword={balance?.has_pay_password ?? false}
                    transferError={transferError}
                    isOutsideWithdrawWindow={isOutsideWithdrawWindow}
                    withdrawWindow={withdrawWindow}
                    onClose={handleCloseTransferModal}
                    onClearError={() => setTransferError(null)}
                    onTransfer={onTransfer}
                />
            )}
            <div style={{ margin: "3.5rem auto 0", width: "100%" }}>
                <div className="mobile-dashboard-panel">
                    {/* 상단 환영 영역 */}
                    <div className="mobile-dashboard-welcome">
                        <h1 className="mobile-dashboard-welcome-title">
                            {MyData.co_nm || "가맹점"}
                        </h1>
                        <div className="mobile-dashboard-welcome-sub">
                            <span className="mobile-dashboard-welcome-badge"><Landmark size={14} style={{ marginRight: "3px" }} /> 가맹점 회원</span>
                        </div>
                    </div>

                    {/* 현금잔고 카드 */}
                    <div className="mobile-dashboard-balance-card">
                        <div className="mobile-dashboard-balance-head">
                            <div className="mobile-dashboard-balance-label">현금잔고</div>

                            {/* <button
                                className="mobile-dashboard-refresh-btn"
                                onClick={() => console.log("refresh!")}
                                aria-label="잔고 새로고침"
                            >
                                <RefreshIcon />
                            </button> */}
                        </div>
                        <div className="mobile-dashboard-balance-body">
                            <span className="mobile-dashboard-balance-amount">
                                {changeNum(Number(balance?.total_balance ?? 0))}<span className="unit">원</span>
                            </span>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
                                <button
                                    style={{
                                        border: "none",
                                        background: isOutsideWithdrawWindow ? "#9ca3af" : "#003050",
                                        color: "#fff",
                                        padding: "6px 12px",
                                        borderRadius: "18px",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        cursor: isOutsideWithdrawWindow ? "not-allowed" : "pointer",
                                    }}
                                    onClick={handleOpenTransferModal}
                                    disabled={isOutsideWithdrawWindow}
                                    title={isOutsideWithdrawWindow && withdrawWindow ? `출금 가능 시간: ${formatTimeForDisplay(withdrawWindow.start)}~${formatTimeForDisplay(withdrawWindow.end)}` : undefined}
                                >
                                    이체
                                </button>
                                {isOutsideWithdrawWindow && withdrawWindow && (
                                    <span style={{ fontSize: "12px", color: "#6b7280" }}>
                                        출금 가능: {formatTimeForDisplay(withdrawWindow.start)}~{formatTimeForDisplay(withdrawWindow.end)}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>


                <div className="content" id="contents" style={{ marginTop: "0px", paddingLeft: "20px", paddingRight: "20px", paddingTop: "50px" }}>
                    <div className="content-wrap" style={{ paddingBottom: "40px" }}>
                        <div className="content-item"><div className="myMenu">
                            <span className="myMenu-title">마이메뉴</span>

                            <Swiper
                                ref={swiperRef}
                                modules={[FreeMode, Mousewheel]}
                                className="myMenu-swiper"
                                slidesPerView="auto"
                                spaceBetween={10}
                                freeMode={{ enabled: true, momentum: true, momentumBounce: true }}
                                mousewheel={{ forceToAxis: true }}  // 세로 스크롤 간섭 최소화
                                grabCursor={true}
                                slidesOffsetBefore={4}
                                slidesOffsetAfter={4}
                            >
                                {items.map((it) => (
                                    <SwiperSlide key={it.key} className="myMenu-slide">
                                        <Link
                                            to={it.link}
                                            className="myMenu-chip"
                                        >
                                            <div className="myMenu-icon">{it.icon}</div>
                                            <span className="myMenu-label">{it.label}</span>
                                        </Link>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                            <div
                                style={{
                                    borderRadius: "14px",
                                    padding: "16px 0px 10px",
                                    width: "100%",
                                }}
                            >
                                {/* 상단 영역 */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: "6px",
                                    }}
                                >
                                    {/* 왼쪽: 제목 */}
                                    <span style={{ fontWeight: 600, fontSize: "16px", color: "#444" }}>
                                        매출
                                    </span>

                                    {/* 오른쪽: 조회 버튼 */}
                                    {/* <button
                                        style={{
                                            border: "none",
                                            background: "#003050",
                                            color: "#fff",
                                            padding: "6px 12px",
                                            borderRadius: "18px",
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            cursor: "pointer",
                                        }}
                                        onClick={onClickSearch} // 이벤트 핸들러 연결
                                    >
                                        조회
                                    </button> */}
                                </div>

                                {/* 안내 문구 */}
                                <div style={{ fontSize: "13px", color: "red", lineHeight: 1.4 }}>
                                    표기된 내용은 실금액과 차이가 날 수 있습니다.
                                </div>
                            </div>


                            {/* 매출: 금일·당월 | 전일·전월 */}
                            <div
                                style={{
                                    borderRadius: "14px",
                                    background: "#fff",
                                    padding: "16px 18px",
                                    width: "100%",
                                    boxShadow: "0 2px 10px rgba(0,0,0,.1)",
                                    marginBottom: "10px"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        justifyContent: "space-between",
                                        gap: "16px",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <div style={{ display: "flex", flexDirection: "column", gap: "14px", flex: "1 1 auto", minWidth: 0 }}>
                                        <div className="sales-segment" role="tablist">
                                            <button
                                                type="button"
                                                role="tab"
                                                aria-selected={salesRangeTab === 'current'}
                                                onClick={() => setSalesRangeTab('current')}
                                            >
                                                금일 / 당월
                                            </button>
                                            <button
                                                type="button"
                                                role="tab"
                                                aria-selected={salesRangeTab === 'past'}
                                                onClick={() => setSalesRangeTab('past')}
                                            >
                                                전일 / 전월
                                            </button>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                            {/* 일별: 금일 또는 전일 */}
                                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                <span style={{ color: "#6B7280", fontSize: "13px", fontWeight: 600, letterSpacing: "-0.02em" }}>
                                                    {salesRangeTab === 'current' ? salesDates.todayStr : salesDates.yesterdayStr}
                                                </span>
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                    <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>매출</span>
                                                    <span style={{ color: "#9CA3AF" }}>-</span>
                                                    <span style={{ fontWeight: 600, color: "#333" }}>
                                                        {salesRangeTab === 'current'
                                                            ? changeNum(walletBalance?.today?.today_sales ?? 0)
                                                            : changeNum(walletBalance?.yesterday?.yesterday_sales ?? 0)}
                                                    </span>
                                                    <span style={{ color: "#6B7280" }}>원</span>
                                                </div>
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                    <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>정산 금액</span>
                                                    <span style={{ color: "#9CA3AF" }}>-</span>
                                                    <span style={{ fontWeight: 600, color: "#333" }}>
                                                        {salesRangeTab === 'current'
                                                            ? changeNum(walletBalance?.today?.today_amount ?? 0)
                                                            : changeNum(walletBalance?.yesterday?.yesterday_amount ?? 0)}
                                                    </span>
                                                    <span style={{ color: "#6B7280" }}>원</span>
                                                </div>
                                            </div>
                                            {/* 월별: 당월 또는 전월 */}
                                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", paddingTop: "10px", borderTop: "1px solid #e5e7eb" }}>
                                                <span style={{ color: "#6B7280", fontSize: "13px", fontWeight: 600, letterSpacing: "-0.02em" }}>
                                                    {salesRangeTab === 'current' ? salesDates.currentMonthStr : salesDates.lastMonthStr}
                                                </span>
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                    <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>매출</span>
                                                    <span style={{ color: "#9CA3AF" }}>-</span>
                                                    <span style={{ fontWeight: 600, color: "#333" }}>
                                                        {salesRangeTab === 'current'
                                                            ? changeNum(walletBalance?.currentMonth?.current_month_sales ?? 0)
                                                            : changeNum(walletBalance?.lastMonth?.last_month_sales ?? 0)}
                                                    </span>
                                                    <span style={{ color: "#6B7280" }}>원</span>
                                                </div>
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                    <span style={{ color: "#555", fontSize: 14, fontWeight: "600" }}>정산 금액</span>
                                                    <span style={{ color: "#9CA3AF" }}>-</span>
                                                    <span style={{ fontWeight: 600, color: "#333" }}>
                                                        {salesRangeTab === 'current'
                                                            ? changeNum(walletBalance?.currentMonth?.current_month_amount ?? 0)
                                                            : changeNum(walletBalance?.lastMonth?.last_month_amount ?? 0)}
                                                    </span>
                                                    <span style={{ color: "#6B7280" }}>원</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        style={{
                                            border: "none",
                                            background: "#F3F4F6",
                                            color: "#4B5563",
                                            padding: "8px 14px",
                                            borderRadius: "18px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            flexShrink: 0,
                                        }}
                                        onClick={onClickHistory}
                                    >
                                        내역
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const parseKRW = (s = "") => {
    if (typeof s === "number") return s;
    const digits = String(s).replace(/[^\d]/g, "");
    return digits ? parseInt(digits, 10) : 0;
};

/** "08:00:00" 또는 "08:00" 형태를 분 단위로 변환 */
function timeStringToMinutes(str) {
    if (!str || typeof str !== "string") return null;
    const parts = str.trim().split(":");
    const h = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10) || 0;
    if (Number.isNaN(h)) return null;
    return h * 60 + m;
}

/** 현재 시각이 start~end 구간 안에 있는지 (같은 날 구간, 로컬 시각 기준) */
function isTimeInWithdrawWindow(startStr, endStr) {
    const startMin = timeStringToMinutes(startStr);
    const endMin = timeStringToMinutes(endStr);
    if (startMin == null || endMin == null) return true;
    const now = new Date();
    const currentMin = now.getHours() * 60 + now.getMinutes();
    if (startMin <= endMin) return currentMin >= startMin && currentMin <= endMin;
    return currentMin >= startMin || currentMin <= endMin;
}

/** "08:00:00" -> "08:00" 표시용 */
function formatTimeForDisplay(str) {
    if (!str || typeof str !== "string") return "";
    const parts = str.trim().split(":");
    if (parts.length >= 2) return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}`;
    return str;
}

function TransferModal({
    currentBalance,
    withdrawable,
    withdrawalFee,
    registeredAccount,
    hasPayPassword,
    transferError,
    isOutsideWithdrawWindow,
    withdrawWindow,
    onClose,
    onTransfer,
}) {
    const [input, setInput] = useState("");
    const amount = useMemo(() => parseKRW(input), [input]);

    // 수수료를 제외한 실제 출금 가능 금액
    const maxWithdrawable = Math.max(0, withdrawable - (withdrawalFee ?? 0));

    const remain = useMemo(
        () => Math.max(0, maxWithdrawable - amount),
        [maxWithdrawable, amount]
    );

    const over = amount > maxWithdrawable;
    const invalid = amount <= 0 || over;

    const hasRegistered = !!registeredAccount;

    const [isLoading, setIsLoading] = useState(false);
    const submitDisabled = invalid || !!transferError || isOutsideWithdrawWindow || !hasRegistered || isLoading;

    // 결제비밀번호 입력 단계
    const [step, setStep] = useState("form"); // "form" | "password"
    const [payPassword, setPayPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const passwordInputRef = useRef(null);

    const handleAll = () => setInput(changeNum(maxWithdrawable));
    const handleChange = (e) => setInput(changeNum(parseKRW(e.target.value)));

    const handleTransfer = useCallback(async () => {
        if (submitDisabled) return;
        // 비밀번호가 필요한 가맹점이면 비밀번호 입력 단계로
        if (hasPayPassword && step === "form") {
            setStep("password");
            setPayPassword("");
            setPasswordError("");
            setTimeout(() => passwordInputRef.current?.focus(), 100);
            return;
        }
        setIsLoading(true);
        try {
            const pw = hasPayPassword ? payPassword : null;
            const result = await onTransfer?.(amount, null, pw);
            if (result?.ok === false) {
                setIsLoading(false);
                // 비밀번호 오류 시 비밀번호 단계에 머무르기
                if (result?.code >= 4000 && step === "password") {
                    setPasswordError(result?.msg ?? "비밀번호가 올바르지 않습니다.");
                    setPayPassword("");
                    setTimeout(() => passwordInputRef.current?.focus(), 100);
                }
                return;
            }
            onClose();
        } catch (e) {
            console.error(e);
            setIsLoading(false);
        }
    }, [amount, submitDisabled, onClose, onTransfer, hasPayPassword, step, payPassword]);

    const handlePasswordSubmit = useCallback(() => {
        if (!payPassword) {
            setPasswordError("비밀번호를 입력해주세요.");
            return;
        }
        setPasswordError("");
        handleTransfer();
    }, [payPassword, handleTransfer]);

    const handleBackToForm = () => {
        setStep("form");
        setPayPassword("");
        setPasswordError("");
    };

    // ESC로 닫기
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);


    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div
                className="modal-sheet"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="transfer-title"
            >
                <div className="modal-head">
                    {step === "password" && (
                        <button onClick={handleBackToForm} aria-label="뒤로" style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", marginRight: "4px", fontSize: "16px", color: "#374151" }}>←</button>
                    )}
                    <h2 id="transfer-title">{step === "password" ? "비밀번호 확인" : "이체"}</h2>
                    <button className="modal-close" onClick={onClose} aria-label="닫기">✕</button>
                </div>

                {step === "form" ? (
                    <>
                        <div className="modal-body">
                            {transferError && (
                                <div className="row" style={{ marginBottom: "12px", padding: "10px 12px", background: "#fef2f2", borderRadius: "8px", color: "#b91c1c", fontSize: "13px" }}>
                                    {transferError.msg}
                                    {transferError.withdrawAllowedStart != null && transferError.withdrawAllowedEnd != null && (
                                        <div style={{ marginTop: "4px", fontWeight: 600 }}>
                                            출금 가능 시간: {formatTimeForDisplay(transferError.withdrawAllowedStart)}~{formatTimeForDisplay(transferError.withdrawAllowedEnd)}
                                        </div>
                                    )}
                                </div>
                            )}
                            {!transferError && isOutsideWithdrawWindow && withdrawWindow && (
                                <div className="row" style={{ marginBottom: "12px", padding: "10px 12px", background: "#fef3c7", borderRadius: "8px", color: "#92400e", fontSize: "13px" }}>
                                    출금 가능 시간이 아닙니다. {formatTimeForDisplay(withdrawWindow.start)}~{formatTimeForDisplay(withdrawWindow.end)}에만 출금 가능합니다.
                                </div>
                            )}
                            <Row label="현재 잔고">
                                <strong>{changeNum(currentBalance)}원</strong>
                            </Row>

                            <Row label="출금가능 잔고">
                                <strong>{changeNum(maxWithdrawable)}원</strong>
                            </Row>

                            <Row label="출금 수수료">
                                <span style={{ color: withdrawalFee === 0 ? "#16a34a" : withdrawalFee > 0 ? "#b45309" : "#9ca3af", fontWeight: 600 }}>
                                    {withdrawalFee == null ? "-" : withdrawalFee === 0 ? "무료" : `${changeNum(withdrawalFee)}원`}
                                </span>
                            </Row>

                            {/* 출금 계좌 */}
                            <div className="row" style={{ flexDirection: "column", alignItems: "stretch", gap: "8px", padding: "12px 0" }}>
                                <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: 500 }}>출금 계좌</span>

                                {hasRegistered ? (
                                    <div style={{ padding: "10px 12px", background: "#f0f7ff", border: "1px solid #003050", borderRadius: "8px" }}>
                                        <div style={{ fontWeight: 600 }}>등록 계좌</div>
                                        <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                                            {registeredAccount.bankName} {registeredAccount.account}
                                            {registeredAccount.accountName && <span style={{ marginLeft: "6px", color: "#9ca3af" }}>({registeredAccount.accountName})</span>}
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ padding: "10px 12px", background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: "8px", color: "#9a3412", fontSize: "12px", fontWeight: 600 }}>
                                        등록된 출금 계좌가 없습니다. 등록 계좌가 있어야 출금할 수 있습니다.
                                    </div>
                                )}
                            </div>

                            <Row label="이체 금액">
                                <div className="amount-input-wrap">
                                    <input
                                        className="amount-input"
                                        inputMode="numeric"
                                        placeholder="0"
                                        value={input}
                                        onChange={handleChange}
                                        style={{ width: "120px" }}
                                    />
                                    <span className="amount-suffix">원</span>
                                    <button className="btn-all" onClick={handleAll}>전액</button>
                                </div>
                            </Row>

                            <RowLast label="출금가능 잔액">
                                {over ?
                                    <p className="field-error">출금가능 잔고를 초과했습니다.</p>
                                    :
                                    <strong>{changeNum(remain)}원</strong>
                                }

                            </RowLast>
                        </div>

                        <div className="modal-foot">
                            <button
                                className={`btn-transfer ${submitDisabled ? "btn-disabled" : ""}`}
                                onClick={handleTransfer}
                                disabled={submitDisabled}
                            >
                                {hasPayPassword ? "다음" : "이체"}
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="modal-body" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <div style={{ width: "48px", height: "48px", borderRadius: "50%", background: "#f0f4f8", display: "flex", alignItems: "center", justifyContent: "center", marginTop: "12px", marginBottom: "16px" }}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect x="5" y="11" width="14" height="10" rx="2" stroke="#003050" strokeWidth="1.8" />
                                    <path d="M8 11V7a4 4 0 1 1 8 0v4" stroke="#003050" strokeWidth="1.8" strokeLinecap="round" />
                                    <circle cx="12" cy="16" r="1.5" fill="#003050" />
                                </svg>
                            </div>
                            <div style={{ fontSize: "13px", color: "#6b7280", marginBottom: "6px" }}>결제비밀번호를 입력해주세요</div>
                            <div style={{ fontSize: "18px", fontWeight: "700", color: "#111827", marginBottom: "24px" }}>
                                {changeNum(amount)}원
                            </div>

                            <input
                                ref={passwordInputRef}
                                type="password"
                                inputMode="numeric"
                                value={payPassword}
                                onChange={(e) => {
                                    const v = e.target.value.replace(/[^0-9]/g, "");
                                    setPayPassword(v);
                                    setPasswordError("");
                                }}
                                onKeyDown={(e) => { if (e.key === "Enter") handlePasswordSubmit(); }}
                                autoComplete="off"
                                placeholder="비밀번호 입력"
                                style={{
                                    width: "200px",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    padding: "12px 16px",
                                    border: `1.5px solid ${passwordError ? "#dc3545" : "#d1d5db"}`,
                                    borderRadius: "10px",
                                    outline: "none",
                                    background: "#fff",
                                    marginBottom: "8px",
                                }}
                                onFocus={(e) => e.target.style.borderColor = passwordError ? "#dc3545" : "#003050"}
                                onBlur={(e) => e.target.style.borderColor = passwordError ? "#dc3545" : "#d1d5db"}
                            />

                            {passwordError && (
                                <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "4px" }}>
                                    {passwordError}
                                </div>
                            )}
                        </div>

                        <div className="modal-foot">
                            <button
                                className={`btn-transfer ${(!payPassword || isLoading) ? "btn-disabled" : ""}`}
                                onClick={handlePasswordSubmit}
                                disabled={!payPassword || isLoading}
                            >
                                {isLoading ? "처리 중..." : "이체"}
                            </button>
                        </div>
                    </>
                )}

                {isLoading && (
                    <div style={{
                        position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
                        background: "rgba(0,0,0,0.35)", borderRadius: "inherit", zIndex: 10
                    }}>
                        <div style={{
                            width: "36px", height: "36px", border: "3px solid rgba(255,255,255,0.3)",
                            borderTopColor: "#fff", borderRadius: "50%",
                            animation: "spin 0.7s linear infinite"
                        }} />
                    </div>
                )}
            </div>
        </div>
    );
}

function Row({ label, children }) {
    return (
        <div className="row">
            <div className="row-label">{label}</div>
            <div className="row-content">{children}</div>
        </div>
    );
}

function RowLast({ label, children }) {
    return (
        <div className="row" style={{ borderTop: "1px solid #eee", paddingTop: "15px" }}>
            <div className="row-label">{label}</div>
            <div className="row-content">{children}</div>
        </div>
    );
}
export default Dashboard;
